export const getDecoyBeaconState = (game) => {
  const owned = !!game.relics?.includes('decoyBeacon');
  const used = game.decoyBeacon?.used === true;
  const available = owned && !used;
  const beforeThrow =
    game.phase === 'bossReady' ||
    (game.phase === 'bossPlayerRolled' &&
      game.bossRoundState?.playerImpactApplied === true) ||
    (game.phase === 'bossRolled' &&
      !Number.isInteger(game.bossLandingIndex) &&
      game.decoyBeacon?.throwRound !== game.bossRound);
  return {
    owned,
    used,
    deployed: available && game.decoyBeacon?.deployed === true,
    canDeploy: available && beforeThrow,
  };
};

export const toggleDecoyBeacon = (game) => {
  const beacon = getDecoyBeaconState(game);
  if (!beacon.canDeploy) return game;
  return {
    ...game,
    decoyBeacon: { ...game.decoyBeacon, deployed: !beacon.deployed },
  };
};

export const startDecoyBeaconThrow = (game) => {
  if (
    !getDecoyBeaconState(game).owned ||
    game.phase !== 'bossRolled' ||
    Number.isInteger(game.bossLandingIndex) ||
    game.decoyBeacon?.throwRound === game.bossRound
  )
    return game;
  return {
    ...game,
    decoyBeacon: { ...game.decoyBeacon, throwRound: game.bossRound },
  };
};

export const consumeDecoyBeacon = (game) =>
  !getDecoyBeaconState(game).deployed
    ? game
    : {
        ...game,
        decoyBeacon: { ...game.decoyBeacon, deployed: false, used: true },
      };
